import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import DetailRow from "../../../components/UI/viewDialogs/DetailRow";
import { checkValue } from "../../../functions/checkValue";
import Modal from "../../../components/portal/Modal";
import HeadingDialog from "../../../components/UI/viewDialogs/HeadingDialog";
import { siteCategoryColor } from "../utils/siteHelpers";
import GradientButton from "../../../components/UI/buttonUI/GradientButton";
import { timeStampToDateAndTime } from "../../../functions/dateTime/timeStampToDateAndTime";
import successIcon from "../../../assets/icons/successIcon.svg";
import GetCheckCross from "../../../components/UI/viewDialogs/GetCheckCross";
import SiteOperatorDisplay from "./site-operator/SiteOperatorDisplay";
import useDelete from "../../../CustomHooks/useAxios/useDelete";

export default function SiteViewDialog({
  closeDialog,
  viewDetails,
  successView,
  successMsg,
  setViewDialogDetails,
}) {
  const navigate = useNavigate();
  let jeName = "";
  let jePhone = "";

  if (viewDetails.lastVisitJE) {
    [jeName, jePhone] = viewDetails.lastVisitJE
      .split(",")
      .map((str) => str.trim());
  }

  const {
    executeDelete,
    isDeleting,
    isDeleteError,
    setIsDeleteError,
    deleteResult,
  } = useDelete();

  /// handle data on delete success
  useEffect(() => {
    if (!deleteResult) return;
    setViewDialogDetails((prev) => ({
      ...prev,
      data: deleteResult,
    }));

    const timer = setTimeout(() => {
      navigate(0);
    }, 2000);

    return () => clearTimeout(timer);
  }, [deleteResult]);

  return (
    <Modal
      onClose={
        successView || isDeleting || deleteResult ? undefined : closeDialog
      }
      modalWidth="view-dialog-content"
      closeIcon={!successView}
    >
      {!successView && <HeadingDialog heading="Site Details" />}
      {successView && (
        <>
          <img
            src={successIcon}
            alt="messageIcon"
            className="mx-auto mb-1 w-9"
          />
          <p className="view-success-msg-d ">{successMsg}</p>
        </>
      )}
      <div className={`max-h-500 px-2 overflow-auto`}>
        <div className="view-dialog-content-wrap">
          <DetailRow title="Site Name" value={viewDetails.name} />
          <DetailRow title="Site Id" value={viewDetails.id} />
          {viewDetails.machine && (
            <>
              <DetailRow
                title="Machine Assigned"
                value={
                  <GetCheckCross checkVal={viewDetails.machine?.isAssigned} />
                }
              />
              <DetailRow title="Machine Id" value={viewDetails.machineID} />
            </>
          )}
          <div className={`${siteCategoryColor(viewDetails.category.name)}`}>
            <DetailRow title="Category" value={viewDetails.category.name} />
          </div>
          <DetailRow
            title="Field Technician(JBCC)"
            value={checkValue(viewDetails.jbccFieldTechnician?.fullName)}
          />
          <DetailRow
            title="Field Technician(JN)"
            value={checkValue(viewDetails.jnFieldTechnician?.fullName)}
          />
          <DetailRow
            title="JE Name"
            value={checkValue(viewDetails.je.name)}
            textJustify="text-justify"
            widthDesc="w-64"
          />
          {jeName && <DetailRow title="Last Visit JE Name" value={jeName} />}
          {jePhone && <DetailRow title="Last Visit JE Phone" value={jePhone} />}
          <DetailRow
            title="Subdivision"
            value={checkValue(viewDetails.je.subDivision.name)}
            textJustify="text-justify"
            widthDesc="w-64"
          />
          {!successView && (
            <>
              <DetailRow
                title="Created By"
                value={checkValue(viewDetails.createdBy.fullName)}
              />
              <DetailRow
                title="Created At"
                value={timeStampToDateAndTime(viewDetails.createdAt)}
              />
            </>
          )}
          <DetailRow
            title="Automation"
            value={<GetCheckCross checkVal={viewDetails.isAutomation} />}
          />
          <DetailRow
            title="Non Automation"
            value={<GetCheckCross checkVal={viewDetails.isNonAutomation} />}
          />
        </div>
        {deleteResult && (
          <p className="text-green text-center pt-2">
            Operator deleted. Refreshing…
          </p>
        )}
        {viewDetails.operator && (
          <SiteOperatorDisplay
            operators={viewDetails.operator}
            dataId={viewDetails.id}
            onDelete={executeDelete}
            deleteState={{
              isDeleting,
              isDeleteError,
              setIsDeleteError,
            }}
          />
        )}
      </div>
      {successView && (
        <div className="pt-5 text-center">
          <GradientButton
            btnText="Ok"
            width="w-28"
            onClick={() => navigate("/site/all")}
          />
        </div>
      )}
    </Modal>
  );
}
